<div class="atn-mosaic-metric">
  <!-- Left icons vertical div -->
  @if (noticeSg(); as notice) {
    <div class="atn-mosaic-metric__left-content">
      <atn-ds-notice-icon
        [style]="notice.style"
        [description]="notice.description"
      />
    </div>
  }
  <!-- Name and content vertical div -->
  <div class="atn-mosaic-metric__center-content">
    @let value = valueSg();
    @if (isReportCardSg()) {
      <div>
        <div class="atn-mosaic-metric__report-card-name">{{ nameSg() }}</div>
        <div class="atn-mosaic-metric__details">
          <!-- Description and event will be displayed stacked when both are provided -->
          @if (descriptionSg(); as description) {
            <div class="atn-mosaic-metric__details-description">
              {{ description }}
            </div>
          }
          @if (eventSg(); as event) {
            <div class="atn-mosaic-metric__details-event">
              @if (event.name) {
                <span>{{ event.name }}</span>
              }
              {{ event.time }}
            </div>
          }
        </div>
      </div>
    }
    <div>
      <div class="atn-mosaic-metric__metric-holder">
        <!-- NOTE: Using span because it doesn't take the whole center content div
         width which makes tooltip appear directly under the metric value, whereas
         if we were to use div it would appear under the center of the div -->
        <span
          [class]="{
            'atn-mosaic-metric__metric-value': true,
            'atn-mosaic-metric__metric-value--good':
              value?.quality === QualityEnum.Good,
            'atn-mosaic-metric__metric-value--bad':
              value?.quality === QualityEnum.Bad,
            'atn-mosaic-metric__metric-value--neutral':
              value?.quality === QualityEnum.Neutral,
          }"
          [atnDsTooltip]="value?.tooltip"
        >
          {{ value?.emphasis }}
        </span>
        <span class="atn-mosaic-metric__metric-description">
          {{ value?.aside }}
        </span>
      </div>
      @if (!isReportCardSg()) {
        <div class="atn-mosaic-metric__name">{{ nameSg() }}</div>
      }
    </div>
    @if (!isReportCardSg()) {
      <div class="atn-mosaic-metric__details">
        <!-- Description and event will be displayed stacked when both are provided -->
        @if (descriptionSg(); as description) {
          <div class="atn-mosaic-metric__details-description">
            {{ description }}
          </div>
        }
        @if (eventSg(); as event) {
          <div class="atn-mosaic-metric__details-event">
            @if (event.name) {
              <span>{{ event.name }}</span>
            }
            {{ event.time }}
          </div>
        }
      </div>
    }
  </div>
  <!-- Right icons vertical div -->
  <div class="atn-mosaic-metric__right-content">
    <!-- TODO: Overflow icon should be implemented. Since content in this div is
    justified with space-around link and overflow will have to be grouped with a
    div since they both should be up -->
    <!-- @if (onClickSg()) {
      <i
        class="atn-icon atn-link"
        (click)="iconClickHandler()"
      ></i>
    } -->
    <atn-widget-overflow-menu
      [actions]="overflowActionsSg()"
      [refId]="refIdSg()"
    />
    @let change = metricChangeSg();
    @if (change) {
      <metric-change [change]="change" />
    }
  </div>
</div>
